import type { SharedValue } from "react-native-reanimated";
import { useAnimatedStyle } from "react-native-reanimated";
import { StyleSheet } from "react-native-unistyles";

import useAnimatedTheme from "$src/core/hooks/use-animated-theme";
import CustomPlatform from "$src/core/utils/platform/platform";

const stylesheet = StyleSheet.create(({ spacing, border, colors }) => ({
  container: {
    gap: spacing(4),
    flexDirection: "column",
    borderRadius: border.radius.md,
    _web: {
      transition: "0.2s ease-in-out",
      _focus: {
        outline: "none",
      },
      _hover: {
        outlineWidth: border.widths.md,
        outlineColor: colors.borderFocus,
        outlineOffset: border.widths.md + spacing(4),
        outlineStyle: "solid",
      },
      "_focus-visible": {
        outlineWidth: border.widths.md,
        outlineColor: colors.borderFocus,
        outlineOffset: border.widths.md + spacing(4),
        outlineStyle: "solid",
      },
    },
  },
  circle: {
    borderRadius: border.radius.full,
    justifyContent: "center",
    alignItems: "center",
    width: {
      xs: spacing(16),
      lg: spacing(20),
    },
    height: {
      xs: spacing(16),
      lg: spacing(20),
    },
    borderWidth: CustomPlatform.select({
      tv: border.widths.xl,
    }),
  },
  icon: {
    color: colors.foregroundOnInverted,
    variants: {
      hasLightIcon: {
        true: {
          color: colors.foregroundDefault,
        },
      },
    },
    width: {
      xs: spacing(8),
      lg: spacing(10),
    },
    height: {
      xs: spacing(8),
      lg: spacing(10),
    },
  },
  name: {
    textAlign: "center",
  },
  column: {
    alignItems: "flex-start",
    gap: spacing(1),
  },
}));

export const useAnimatedStyles = ({
  isFocused,
}: {
  isFocused: SharedValue<boolean>;
}) => {
  const animatedTheme = useAnimatedTheme();

  const circleStyle = useAnimatedStyle(() => {
    const { colors } = animatedTheme.value;

    return {
      borderColor: isFocused.value ? colors.borderFocus : "transparent",
    };
  });

  return {
    circleStyle,
  };
};

export default stylesheet;
